import script from "./PreviewSubmissionAnswer.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewSubmissionAnswer.vue?vue&type=script&setup=true&lang=js"

import "./PreviewSubmissionAnswer.vue?vue&type=style&index=0&id=222eb85e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222eb85e"]])

export default __exports__